import React from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';

import { questionLayoutPropType } from '../../../config/richTextConfig/questionLayout';
import TextQuestionRichText from '../../../domains/richText/components/TextQuestionRichText';
import ImageQuestionForm from './ImageQuestionForm/ImageQuestionForm';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class ImageQuestion extends React.Component {
  static propTypes = {
    block: PropTypes.shape({
      clientUuid: PropTypes.string.isRequired,
      required: PropTypes.bool,
      content: PropTypes.object,
    }).isRequired,
    isCloned: PropTypes.bool,
    isInPreviewMode: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    inputField: PropTypes.func.isRequired,
    layout: questionLayoutPropType,
    initialValues: PropTypes.object,
    styling: propTypeBlockStyling,
    questionNumber: PropTypes.number,
  };
  render = () => {
    const {
      block,
      block: { clientUuid, required, content },
      isCloned,
      isInPreviewMode = false,
      initialValues,
      layout,
      inputField,
      handleSubmit,
      styling,
      questionNumber,
    } = this.props;

    const isConditionalQuestion = !!(block.logic && block.logic.message);

    return (
      <div>
        {isInPreviewMode &&
          isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
        <TextQuestionRichText
          questionNumber={questionNumber}
          layout={layout}
          content={content}
          required={required}
          styling={styling}
        />
        <ImageQuestionForm
          form={generateQuestionFormName(clientUuid, isCloned)}
          inputField={inputField}
          onSubmit={handleSubmit}
          initialValues={initialValues}
          block={block}
          styling={styling}
        />
      </div>
    );
  };
}

export default ImageQuestion;
